import { Card, Col, Progress, Row, Tag, Typography } from 'antd'
import { useEffect, useState } from 'react'
import VideoHistoryService from '../../services/VideoHistoryService';
import { NavLink } from 'react-router-dom';

function VideoHistory() {
  const { Text } = Typography;
  const [loading, setLoading] = useState<boolean>(false)
  const [data, setData] = useState<any[]>([])

  // Renk tanımları
  const colors = [
    'rgba(253, 165, 199, 1)',
    'rgba(240, 211, 29, 1)',
    'rgba(114, 63, 231, 1)',
    'rgba(250, 111, 18, 1)'
  ]
  // %30 opak arka plan renkleri
  const bgColors = colors.map(c => c.replace(/1\)$/, '0.1)'))

  useEffect(() => {
    getAllVideoHistoryMe();
  }, [])

  const calcPercent = (video: any) =>
    Math.ceil((video.duration / video.videoDuration) * 100)

  const getAllVideoHistoryMe = () => {
    setLoading(true);
    VideoHistoryService.getAllMe()
      .then((response: any) => {
        setData(response.data)
      })
      .catch(console.error)
      .finally(() => setLoading(false))
  };

  return (
    <Card loading={loading} className="pt-0 video-history" title="Öğrenmeye Devam Et">
      <Row gutter={[24, 24]}>
        {data.map((video, index) => (
          index < 4 && (
          <Col key={video.videoId} xs={24} sm={12} md={12} lg={8} xl={6}>
            <NavLink to={`/video/${video.videoId}/subject/${video.subjectId}/course/${video.courseId}/unit/${video.unitId}/lesson/${video.lessonId}#duration=${video.duration}
            `}>
              <Card
                style={{ height: '100%' }}
                bodyStyle={{ padding: 16, minHeight: 90 }}
                cover={<img src={video.videoCover} alt={video.videoTitle} />}
              >
                <Tag
                  className="mt-16"
                  style={{
                    backgroundColor: bgColors[index],
                    color: colors[index],
                    fontWeight: 500
                  }}
                >
                  {video.courseName}
                </Tag>
                <Text className="mt-8 d-block">{video.videoTitle}</Text>
                <Progress
                  strokeColor={colors[index]}
                  percent={calcPercent(video)}
                  size="default"
                  showInfo={false}
                />
              </Card>
            </NavLink>
          </Col>
          )
        ))}
      </Row>
    </Card>
  )
}

export default VideoHistory
